<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules"  label-position="top">
                <Row :gutter="32">
                    <Col span="24">
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 项目完工确认</template>
                            <Row :gutter="32">
                                <Col span="24">
                                    <FormItem label="验收结果">
                                        <RadioGroup v-model="Forms.status" type="button" button-style="solid">
                                            <Radio :label="11">通过验收</Radio>
                                            <Radio :label="10">未通过验收</Radio>
                                        </RadioGroup>
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row :gutter="32">
                                <Col span="24">
                                    <FormItem v-if="Forms.status === 10" label="驳回原因" prop="reject_remark" :rules="[{required: true, message: '请输入驳回原因', trigger: 'blur'}]">
                                        <Input v-model="Forms.reject_remark" type="textarea" :rows="4" clearable placeholder="驳回原因"  />
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row :gutter="32" v-if="Forms.status === 11">
                                <Col span="12">
                                    <FormItem label="甲方验收人" prop="acceptance_name" :rules="[{ required: true, message: '请输入甲方验收人', trigger: 'blur'}]">
                                        <Input v-model="Forms.acceptance_name" clearable placeholder="" />
                                    </FormItem>
                                </Col>
                                <Col span="12">
                                    <FormItem label="甲方验收人联系电话" prop="acceptance_mobile" :rules="[{ required: true, message: '请输入甲方验收人联系电话', trigger: 'blur'}]">
                                        <Input v-model="Forms.acceptance_mobile" clearable placeholder="" />
                                    </FormItem>
                                </Col>
                                <Col span="12">
                                    <FormItem label="验收日期" prop="acceptance_true_time" :rules="[{required: true, type:'date', message: '请选择验收日期', trigger: 'change'}]">
                                        <DatePicker type="date" format="yyyy-MM-dd" v-model="Forms.acceptance_true_time" placeholder="验收日期" class="width-100"  />
                                    </FormItem>
                                </Col>
                                <Col span="12">
                                    <FormItem label="维保有效期" prop="protect_time" :rules="[{required: true, type:'date', message: '请选择维保有效期', trigger: 'change'}]">
                                        <DatePicker type="date" format="yyyy-MM-dd" v-model="Forms.protect_time" placeholder="维保有效期" class="width-100"  />
                                    </FormItem>
                                </Col>
                                <Col span="24">
                                    <FormItem label="验收清单" prop="acceptance_image" :rules="[{required: true, type:'array', message: '请上传验收清单', trigger: 'change'}]">
                                        <Upload
                                            :show-upload-list="false"
                                            :action="upload_url"
                                            :headers = "{'token': $store.state.token}"
                                            :format="['jpg','jpeg','png','gif']"
                                            :max-size="10 * 1024"
                                            :on-success="handleSuccess"
                                            :on-format-error="handleFormatError"
                                            :on-exceeded-size="handleMaxSize"
                                            :before-upload="handleBeforeUpload">
                                            <div class="uploads">
                                                <div class="upload-images-icon cursor" v-if="Forms.acceptance_image.length < 10">
                                                    <Icon type="md-cloud-upload" size="24" />
                                                    <span>点击上传</span>
                                                </div>
                                                <div class="upload-images" v-for="(item,index) in Forms.acceptance_image" :key="index" @click.stop="">
                                                    <img :src="site_url + item">
                                                    <div class="show" @click.stop="PhotoView(site_url + item)">预览</div>
                                                    <div class="del" @click.stop="PhotoDelete(index)"><Icon type="md-close" /></div>
                                                </div>
                                            </div>
                                        </Upload>
                                    </FormItem>
                                </Col>

                                <Col span="24">
                                    <FormItem label="备注信息" prop="remark">
                                        <Input v-model="Forms.remark" type="textarea" :rows="8" clearable placeholder="备注信息" />
                                        <small class="text-danger">提示：请勿删除原有备注信息</small>
                                    </FormItem>
                                </Col>
                            </Row>

                        </Card>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">确认验收</Button>
            </div>
        </div>

        <!-- 预览图片 -->
        <Modal
            v-model="is_view_box"
            title="预览"
            :width="840"
            :mask-closable="true"
            :footer-hide="true"
            @on-cancel="PhotoViewClose()">
            <div class="flex-image-box">
                <img :src="view_url" class="flex-image-box-show">
            </div>
        </Modal>

    </Drawer>
</template>

<script>

import {getProjectContentDetail, workAcceptanceProject} from "@/apis/project";

export default {
    name: 'ProjectAcceptance',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '项目验收',
            isBox : false,
            upload_url : this.$uploadApi,
            site_url : this.$siteApi,
            is_view_box : false,
            view_url : '',
            Forms : {
                project_id: '',
                status: 11,
                reject_remark: '',
                acceptance_name: '',
                acceptance_mobile: '',
                acceptance_true_time: '',
                protect_time: '',
                acceptance_image: [],
                remark: '',
            },
            Rules : {

            }
        }
    },
    methods: {

        /**
         功能：图片预览
         time: 2025-17-15 10:17:00
         **/
        PhotoView(url){
            if(url){
                this.view_url = url;
                this.is_view_box = true;
            }
        },
        /**
         功能：图片删除
         time: 2025/12/15 10:21
         **/
        PhotoDelete(index){
            let that = this;
            that.Forms.acceptance_image.splice(index , 1);
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleSuccess(res){
            let that = this;
            if(res.code == 100){
                this.Forms.acceptance_image.push(res.data.url);
            }else{
                that.$Message.error({ background: true,duration:3, content: res.msg});
            }
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleFormatError(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '只支持 jpg | png | gif 文件 ' });
            return false;
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleMaxSize(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '图片大小不能超出 10M' });
            return false;
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleBeforeUpload(){
            let that = this;
            if(that.Forms.acceptance_image.length >= 10){
                that.$Message.error({ background: true,duration:3, content: '最多只能上传 10 张图' });
                return false;
            }
            return true;
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        PhotoViewClose(){
            this.is_view_box = false;
            this.view_url = '';
        },
        /**
         功能：
         time: 2025/12/27 14:59
         **/
        GetDetail(project_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getProjectContentDetail(project_id).then(e => {
                let re = e.data;
                that.Forms.remark = re.remark ? re.remark : '';
            })
        },
        /**
         功能：
         time: 2025/12/17 10:47
         **/
        show(project_id, name){
            this.isBox = true;
            this.title = name + ' - 项目验收';
            if(project_id){
                this.Forms.project_id = project_id;
                this.GetDetail(project_id);
            }
        },
        /**
         功能：
         time: 2025/12/20 09:24
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    workAcceptanceProject(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2025/12/20 11:54
         **/
        FormReset(){
            this.isBox = false;
            this.title = '项目验收';
            this.$refs['Forms'].resetFields();
            this.Forms = {
                project_id: '',
                status: 11,
                reject_remark: '',
                acceptance_name: '',
                acceptance_mobile: '',
                acceptance_true_time: '',
                protect_time: '',
                acceptance_image: [],
                remark: '',
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
